export default __webpack_public_path__ + "static/media/ABI-10_614 - Sarath Shanmugam A.8c70d3f6.jpeg";